import { createAsyncThunk } from '@reduxjs/toolkit';

import { resetDataApp } from '../../entities/auth/lib';

export const logout = createAsyncThunk('auth/logout', () => {
  resetDataApp();
});
